import { RemoteDataTable } from '@common/components/table/RemoteDataTable';
import { HospitalModel, MacroListingModel } from '@common/models';
import { MacroType } from '@common/models/Enums/MacroType';
import { CommunicationTemplateSearchStore } from '@common/stores/CommunicationTemplateSearchStore';
import { DateTime } from 'luxon';
import { observer } from "mobx-react";
import React from 'react';
import { PulseLoader } from 'react-spinners';

interface IProps {
    onCommunicationTemplateSelected: (macroId: number) => void;
    hospital: HospitalModel | undefined,
    searchStore: CommunicationTemplateSearchStore,
    macroScope?: MacroType
}

export const CommunicationTemplatesTable = observer((props: IProps) => {
    const CreatedBy = {
        name: "Created By",
        sortable: false,
        selector: (row: MacroListingModel) => row.createdBy,
        minWidth: "12rem"
    }

    const Type = {
        name: "Type",
        sortable: false,
        selector: (row: MacroListingModel) => row.macroTypeName,
        minWidth: "3rem"
    }

    const Access = {
        name: "Access",
        sortable: false,
        selector: (row: MacroListingModel) => row.assignedTo,
        minWidth: "12rem"
    }

    const Name = {
        name: "Name",
        sortable: false,
        selector: (row: MacroListingModel) => row.name,
        minWidth: "18rem"
    }

    const DateCreated = {
        name: "Date Created",
        sortable: false,
        selector: (row: MacroListingModel) => row.dateCreated.setZone(props.hospital?.store?.timezoneName).toLocaleString(DateTime.DATE_SHORT),
        minWidth: "7rem"
    }

    const Status = {
        name: "Status",
        sortable: false,
        selector: (row: MacroListingModel) => row.isActive ? "Active" : "Inactive",
        minWidth: "3rem"
    }

    const Action = {
        name: "Action",
        sortable: false,
        cell: (row: MacroListingModel) => (
            <i className="cursor-pointer fa fa-pencil" onClick={() => props.onCommunicationTemplateSelected(row.macroId)} />
        ),
        minWidth: "4rem",
        center: true,

    }

    const FullDataTableColumns = [
        CreatedBy,
        Type,
        Access,
        Name,
        DateCreated,
        Status,
        Action
    ]

    const ProviderDataTableColumns = [
        Name,
        CreatedBy,
        Action
    ]

    return <RemoteDataTable
        columns={props.macroScope == MacroType.Provider ? ProviderDataTableColumns : FullDataTableColumns}
        persistTableHead={true}
        progressPending={props.searchStore.isLoading}
        progressComponent={<PulseLoader />}
        searchResult={props.searchStore.searchResults}
        onChangePage={(page: number) => { props.searchStore.changePage(page) }}
        onChangeRowsPerPage={(rowsPerPage) => props.searchStore.updateSearchParams({ top: rowsPerPage })}
        pagination={true}
        paginationServer={true}
        sortServer={true}
        onSort={props.searchStore.updateRemoteDTSort}
        paginationPerPage={props.searchStore.searchParams.top}
        onRowClicked={row => props.onCommunicationTemplateSelected(row.macroId)}
    />
})
